import { NgModule } from '@angular/core';
import { SeoUiModule } from '@sdvor/seo/ui';
import { SeoDataAccessModule } from '@seo/data-access';
import { SeoFeatureModule } from '@seo/feature';

@NgModule({
  imports: [SeoUiModule, SeoFeatureModule, SeoDataAccessModule],
})
export class SdvorSeoShellModule {}
